<template>
  <div v-if="landingPageData.id !== null">
    <div
      v-if="userData !== null"
      class="demo-spacing-0"
    >
      <b-alert
        variant="warning"
        show
      >
        <div class="alert-body">
          <span v-if="$router.currentRoute.params.slug !== undefined && $router.currentRoute.params.slug.slice(0, 2) === '$2'">
            You are viewing landing page for internal use only. <strong>You can fill form manually.</strong>
          </span>
          <span v-else>During landing page preview, all form submission <strong>will not be recorded.</strong></span>
        </div>
      </b-alert>
    </div>

    <b-overlay
      v-if="checkActiveLPDate() && assignedSalespersons.length > 0 && landingPageCompanySlugState"
      :show="overlay"
      variant="light"
      :opacity="0.7"
      blur="2px"
      rounded="sm"
    >
      <HeaderSection :landing-page-data="landingPageData" />
      <AboutSection
        :body-description="body_description"
        :landing-page-data="landingPageData"
        :social-media="socialMedia"
      />
      <ContactSection
        :form-id="formId"
        :submit-button="submitButton"
        :aggreement="aggreement"
        :user-data="userData"
        :landing-page-data="landingPageData"
        :redirect-to-wa="redirectToWa"
        :assigned-salesperson-options="assignedSalespersonOptions"
        :is-manual-input="$router.currentRoute.params.slug !== undefined && $router.currentRoute.params.slug.slice(0, 2) === '$2'"
      />
      <FooterSection :landing-page-data="landingPageData" />
    </b-overlay>

    <div
      v-else
      class="misc-inner p-2 p-sm-3"
    >
      <div class="w-100 text-center">
        <div>
          <h2 class="mb-1">
            Oops! This landing page is not available at the moment. 🚀
          </h2>
          <p class="mb-3">
            Sorry about that. If you still need help, visit our support page.
          </p>
          <b-button
            variant="gradient-primary"
            href="/"
          >
            Go to homepage
          </b-button>
        </div>
        <b-img
          fluid
          :src="require('@/assets/images/pages/coming-soon.svg')"
          alt="Coming soon page"
        />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import store from '@/store'
import { BAlert, BButton, BImg, BOverlay } from 'bootstrap-vue'
import HeaderSection from './components/HeaderSection.vue'
import AboutSection from './components/AboutSection.vue'
import ContactSection from './components/ContactSection.vue'
import FooterSection from './components/FooterSection.vue'

export default {
  components: {
    BAlert,
    BButton,
    BImg,
    BOverlay,
    HeaderSection,
    AboutSection,
    ContactSection,
    FooterSection,
  },
  data() {
    return {
      overlay: false,
      landingPageCompanySlugState: true,
      socialMedia: true,
      body_description: '',
      aggreement: '',
      formId: null,
      userData: null,
      assignedSalespersons: [],
      assignedSalespersonOptions: [],
      submitButton: {
        label: '',
        color: '',
      },
      redirectToWa: {
        is_redirect_to_wa: false,
        wa_phone_number: null,
        wa_message: null,
      },
      landingPageData: {
        id: null,
        picture_link: null,
        picture_hero_link: null,
        description: '',
        body_description: '',
        aggreement: '',
        expired_finish_date: '',
        expired_start_date: '',
        label_submit_button: '',
        color_submit_button: '',
        title: null,
        form_id: null,
        text_link: [],
        color_link: [],
        url_link: [],
        marketing_link: '',
        instagram: '',
        facebook: '',
        linkedin: '',
        youtube: '',
        tiktok: '',
      },
      formData: {
        landing_page_slug: null,
        landing_page_query: this.$route.query,
      },
    }
  },
  created() {
    this.getSelf()
    this.getLandingPageForm()
    this.getAssignedSalesperson()
  },
  methods: {
    getLandingPageForm() {
      let payload = null
      let lpGetURL = ''
      if (this.$router.currentRoute.params.uuid !== undefined) {
        payload = { uuid: this.$router.currentRoute.params.uuid }
        lpGetURL = 'menu-landing-page/getLandingPageFormByUuid'
      } else if (this.$router.currentRoute.params.slug !== undefined) {
        if (this.$router.currentRoute.params.slug.slice(0, 2) === '$2') {
          payload = { uncountSlug: this.$router.currentRoute.params.slug }
          lpGetURL = 'menu-landing-page/getLandingPageFormByUncountSlug'
        } else {
          payload = { slug: this.$router.currentRoute.params.slug }
          lpGetURL = 'menu-landing-page/getLandingPageFormBySlug'
        }
      }
      this.overlay = true
      store.dispatch(lpGetURL, payload)
        .then(response => {
          const strBody = String(response.data.data.body_description)
          this.body_description = strBody.replace(/rel="/g, 'rel="nofollow ')

          const strAgreement = String(response.data.data.aggreement)
          this.aggreement = strAgreement.replace(/rel="/g, 'rel="nofollow ')

          this.landingPageData = response.data.data
          this.landingPageData.text_link = JSON.parse(this.landingPageData.text_link)
          this.landingPageData.color_link = JSON.parse(this.landingPageData.color_link)
          this.landingPageData.url_link = JSON.parse(this.landingPageData.url_link)
          this.formId = this.landingPageData.form_id
          this.submitButton.label = this.landingPageData.label_submit_button
          this.submitButton.color = this.landingPageData.color_submit_button

          this.redirectToWa.is_redirect_to_wa = this.landingPageData.thank_you.redirect_to_wa == 1
          this.redirectToWa.wa_phone_number = this.landingPageData.thank_you.wa_phone_number
          this.redirectToWa.wa_message = this.landingPageData.thank_you.wa_message

          this.socialMedia = (
            this.landingPageData.instagram
            || this.landingPageData.facebook
            || this.landingPageData.linkedin
            || this.landingPageData.youtube
            || this.landingPageData.tiktok
          )

          const companyName = this.landingPageData.creator.company.name
          document.title = `${companyName}  -  ${this.landingPageData.analytic.page_title}`
          this.formatCompanySlug(companyName)

          const uri = window.location.search.substring(1)
          const params = new URLSearchParams(uri)
          if (uri === '') {
            this.overlay = false
          } else if (params.get('channel')) {
            const marketingLinks = this.landingPageData.marketing_link
            marketingLinks.map(val => {
              if (val.param === params.get('channel')) {
                this.overlay = false
              } else {
                const updatedQuery = { ...params }
                delete updatedQuery.channel
                this.$router.push({ query: updatedQuery })
                this.overlay = false
              }
              return true
            })
          }
          this.storeVisitor()
        })
        .catch(error => {
          console.log(error)
          if (error.response !== undefined) {
            this.$swal({
              icon: 'error',
              variant: 'danger',
              title: 'Error occured',
              text: 'Landing Page with that company or slug not found !',
            })
          }
        })
    },
    formatCompanySlug(companyName) {
      if (this.$router.currentRoute.params.company !== undefined) {
        if (companyName.replace(/\W+/g, ' ').replace(/\s/g, '-').toLowerCase() === this.$router.currentRoute.params.company) {
          this.landingPageCompanySlugState = true
        } else {
          this.landingPageCompanySlugState = false
        }
      }
    },
    storeVisitor() {
      this.formData.landing_page_slug = this.$router.currentRoute.params.slug
      if (this.userData !== null) {
        this.formData.user_id = this.userData.id ?? null
      }
      if (this.$router.currentRoute.params.slug !== undefined) {
        if (this.$router.currentRoute.params.slug.slice(0, 2) !== '$2') {
          store.dispatch('menu-landing-page/storeVisitor', this.formData)
            .catch(error => { console.log(error) })
        }
      }
    },
    getSelf() {
      store.dispatch('app-user/getSelf')
        .then(response => { this.userData = response.data })
        .catch(error => { console.log(error) })
    },
    checkActiveLPDate() {
      return (
        new Date(this.landingPageData.expired_start_date) <= new Date()
        && new Date(this.landingPageData.expired_finish_date) >= new Date()
      )
    },
    async getAssignedSalesperson() {
      if (this.$router.currentRoute.params.uuid !== undefined) {
        await store.dispatch('menu-landing-page/getAssignedSalespersonByUuid', {
          uuid: this.$router.currentRoute.params.uuid,
        })
          .then(response => {
            this.assignedSalespersons = response.data.data.origin
            this.assignedSalespersonOptions = response.data.data.options
          })
          .catch(error => { console.log(error) })
      } else if (this.$router.currentRoute.params.slug !== undefined) {
        if (this.$router.currentRoute.params.slug.slice(0, 2) === '$2') {
          await store.dispatch('menu-landing-page/getAssignedSalespersonByUncountSlug', {
            uncountSlug: this.$router.currentRoute.params.slug,
          })
            .then(response => {
              this.assignedSalespersons = response.data.data.origin
              this.assignedSalespersonOptions = response.data.data.options
            })
            .catch(error => { console.log(error) })
        } else {
          await store.dispatch('menu-landing-page/getAssignedSalespersonBySlug', {
            slug: this.$router.currentRoute.params.slug,
          })
            .then(response => {
              this.assignedSalespersons = response.data.data.origin
              this.assignedSalespersonOptions = response.data.data.options
            })
            .catch(error => { console.log(error) })
        }
      }
    },
  },
}
</script>
